<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1A5Konx/tc-custom/9781680571813.jpg?1701061714594" alt="This image is the cover for the book Throne of Saturn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Throne of Saturn
      </h1>
      <p class="bookDescription body article font2">
        <p>Master novelist Drury probes the controversy and political machinations as America strives to land on Mars . . .</p><p>A mission that may be torn apart by the nation’s turmoil . . .</p><p><i>The Throne of Saturn</i> shows the struggle of dedicated and courageous astronauts to set foot on the red planet and maintain our quest for the stars</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allen Drury
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49faed32